import axios from "axios";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;

async function getAll(payload) {
    const result = await axios.post(apiUrl + "/admin/dropdown/payment",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function getMaster(payload) {
    const result = await axios.post(apiUrl + "/admin/getmasters",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function getBroker(payload) {
    const result = await axios.post(apiUrl + "/admin/getbrokers",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function getUsers(payload) {
    const resultuser = await axios.post(apiUrl + "/admin/dropdown/getusers/jv",payload,{
        headers: jsonHeader}
    );
    return resultuser.data || [];
}

async function getPaymententry(payload) {
    const resultuser = await axios.post(apiUrl + "/payment/entry",payload,{
        headers: jsonHeader}
    );
    return resultuser.data || [];
}

export const CashEntryService = {
    getAll,
    getMaster,
    getBroker,
    getUsers,
    getPaymententry,
}